/**
 * aiChatFeedback · 提交一条 AI 助手消息的点赞 / 点踩反馈
 *
 * 后端：POST /web/workgroup/folder/ai/chat/feedback
 *
 * 入参：
 *   {
 *     conversation_id: string,
 *     group_id: string,           // UUID 形式 · BFF 会校验
 *     message_id: number,         // ai_chat_message.id · AssistantMessage.backendMessageId
 *     feedback: 1 | 2             // 1 点赞 · 2 点踩（0 撤销由后端约定，本前期不传）
 *   }
 *
 * 失败：throw Error · 调用方可 catch 后乐观更新回滚
 */

declare const __API_SERVER_HOST__: string

interface FeedbackRequest {
  conversation_id: string
  group_id: string
  message_id: number
  feedback: 1 | 2
}

interface FeedbackResponse {
  status?: number
  msg?: string
}

export async function sendAiChatFeedback(
  req: FeedbackRequest,
  signal?: AbortSignal
): Promise<FeedbackResponse> {
  const url = __API_SERVER_HOST__ + '/web/workgroup/folder/ai/chat/feedback'
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req),
    signal
  })
  if (!res.ok) {
    throw new Error(`HTTP ${res.status} ${res.statusText}`)
  }
  const data = (await res.json()) as FeedbackResponse
  // 业务侧 · status !== 0 视作失败（沿用 fetchHelper 通用约定）
  if (data && data.status != null && data.status !== 0) {
    const tip = data.msg || `反馈失败 status=${data.status}`
    throw new Error(tip)
  }
  return data
}
